import SvgMap from "./mapHandler/SvgMap.js";
import CanvasMap from "./mapHandler/CanvasMap.js";

if (document.getElementById('map')) {
    const svgMap = new SvgMap('map');
    svgMap.initMap();
    svgMap.loadCadastreFromACF(WPData.postId, WPData);
}

if (document.getElementById('map-canva')) {
    const canvasMap = new CanvasMap('map-canva');
    canvasMap.initMap();
    canvasMap.loadCadastreFromACF(WPData.postId, WPData);
}